import { ExternalId, SourceKind } from 'types/schema-generated-types';
import Config from 'config';

export type ExternalIdEntity = {
  externalId: ExternalId | null | undefined;
} & { [key: string]: any };
export type MaybeGetExternalIdArgs = {
  entities: ExternalIdEntity[];
  candidateSourceId: string;
};

const { validExternalIdSourceKinds } = Config;

const findOrgExternalIdSourceKind = (entities: ExternalIdEntity[]): SourceKind | undefined => {
  const result: ExternalIdEntity | undefined = entities.find(entity =>
    validExternalIdSourceKinds.includes(entity.externalId?.sourceKind as SourceKind)
  );

  return result?.externalId?.sourceKind;
};

const maybeGetExternalId = (
  args: MaybeGetExternalIdArgs
): { externalId: { sourceId: string; sourceKind: SourceKind } } | undefined => {
  const sourceKind = findOrgExternalIdSourceKind(args.entities);

  return sourceKind
    ? {
        externalId: {
          sourceId: args.candidateSourceId,
          sourceKind
        }
      }
    : undefined;
};

export default maybeGetExternalId;
